<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm w-full">
        <select-warehouse :isMultiple="true" ref="select_warehouse" @data="setWarehouse"></select-warehouse>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm w-full">
        <select-driver @data="setDriver" ref="select_driver"></select-driver>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Daily Closing Status</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect v-model="selectedDailyClosingStatus" :options="optionDailyClosingStatus" :multiple="true"
          :allow-empty="false" :group-select="false" :max-height="100" :limit="3" placeholder="Type to search"
          label="label" track-by="value" />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Only Daily Closing Exception</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-switch v-model="onlyException">
          <span slot="on">Yes</span>
          <span slot="off">No</span>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Daily Closing Date</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full flex">
        <date-range-picker style="min-height: 40px" class="w-full" ref="picker" opens="left"
          :locale-data="{ firstDay: 1, format: 'dd Mon yyyy' }" :singleDatePicker="false" :timePicker="false"
          :timePicker24Hour="false" :showWeekNumbers="false" :showDropdowns="false" :autoApply="true" :clear="true"
          v-model="validity" :linkedCalendars="true">
          <template v-slot:input="picker">
            {{ dateFormat(picker.startDate) }} -
            {{ dateFormat(picker.endDate) }}
          </template>
        </date-range-picker>
      </div>
    </div>

    <div class="vx-row mt-2 ml-2">
      <vs-button class="ml-2" color="primary" type="border" icon-pack="feather" icon="icon-filter"
        @click="handleFilter()">Filter</vs-button>

      <!-- export -->
      <vs-button class="ml-2" color="primary" type="border" icon-pack="feather" icon="icon-download"
        @click="handleExport('excel')">Export</vs-button>

      <!-- reset -->
      <vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"
        @click="handleReset()">Reset</vs-button>
    </div>

    <div class="">
      <vs-table search stripe border description :sst="false" :data="table.data" :max-items="table.length"
        :total="table.length" @change-page="handleChangePage">
        <template slot="thead">
          <vs-th>No</vs-th>
          <vs-th>Daily Closing Date</vs-th>
          <vs-th>Warehouse Code</vs-th>
          <vs-th>Warehouse Name</vs-th>
          <vs-th>Driver Name</vs-th>
          <vs-th>Vehicle No</vs-th>
          <vs-th>Handover Complete</vs-th>
          <vs-th>Start Session</vs-th>
          <vs-th>End Session</vs-th>
          <vs-th>Count of PI</vs-th>
          <vs-th>Count of PI COD</vs-th>
          <vs-th>PI COD Amount</vs-th>
          <vs-th>Count of PI POD Confirm</vs-th>
          <vs-th>Count of PI COD Collected</vs-th>
          <vs-th>Invoice COD Amount</vs-th>
          <vs-th>Invoice COD Amount Collected</vs-th>
          <vs-th>POD Confirm</vs-th>
          <vs-th>Collection Complete</vs-th>
          <vs-th>Daily Closing</vs-th>
          <vs-th>Daily Closing Status</vs-th>
          <vs-th>Daily Closing With Exception Status</vs-th>
          <vs-th>Daily Closing With Exception Note</vs-th>
        </template>
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ table.row_number_start + indextr }}</vs-td>
            <vs-td>{{ formatDate(tr.daily_closing_date) }}</vs-td>
            <vs-td>{{ tr.wh_code }}</vs-td>
            <vs-td>{{ tr.wh_name }}</vs-td>
            <vs-td>{{ tr.driver_name }}</vs-td>
            <vs-td>{{ tr.vehicle_number }}</vs-td>
            <vs-td>{{ formatDateTime(tr.handover_complete) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.start_session) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.end_session) }}</vs-td>
            <vs-td>{{ tr.count_pi }}</vs-td>
            <vs-td>{{ tr.count_pi_cod }}</vs-td>
            <vs-td>{{ formatNumber(tr.invoice_cod_amount) }}</vs-td>
            <vs-td>{{ tr.count_pi_pod_confirm }}</vs-td>
            <vs-td>{{ tr.count_pi_cod_collected }}</vs-td>
            <vs-td>{{ formatNumber(tr.amount_pi_cod) }}</vs-td>
            <vs-td>{{ formatNumber(tr.amount_pi_cod_collected) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.pod_confirm) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.collection_complete) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.daily_closing_end) }}</vs-td>
            <vs-td>{{ tr.daily_closing_status }}</vs-td>
            <vs-td>{{ tr.exception_status }}</vs-td>
            <vs-td>{{ tr.exception_notes }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import SelectWarehouse from "./_components/select-warehouse.vue";
import SelectDriver from "./_components/select-driver.vue";

export default {
  components: {
    DateRangePicker,
    SelectWarehouse,
    SelectDriver,
  },
  data() {
    const today = moment();
    return {
      table: this.tableDefaultState(),
      baseUrl: "/api/sfa/v1/daily-closing/driver",
      warehouses: [],
      warehouseIDs: null,
      driver: {
        id: null,
        name: null,
      },
      driverIDs: null,
      selectedDailyClosingStatus: [],
      optionDailyClosingStatus: [
        { id: 0, label: "ALL", value: "ALL" },
        { id: 1, label: "No Activity", value: "no_activity" },
        { id: 2, label: "Not Yet Daily Closing", value: "not_yet" },
        { id: 3, label: "Daily Closing Done", value: "done" },
      ],
      dailyClosingStatusIDs: "0",
      onlyException: false,
      validity: {
        startDate: today,
        endDate: today,
      },
    };
  },
  methods: {
    handleReset() {
      this.$router.go(0);
    },
    setDriver(id, name) {
      this.driver.id = id;
      this.driver.name = name;
    },
    setWarehouse(selecteds) {
      const hasAll = selecteds.some(item => item.id === 0);
      if (hasAll) {
        this.warehouseIDs = "0";
        return;
      }
      const ids = selecteds.map(item => item.id);
      this.warehouseIDs = ids.join(',');
    },
    handleExport(file) {
      if (this.table.total == 0) {
        this.$vs.notify({
          title: "Error",
          text: "No data to export",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      let driver_ids = [];
      driver_ids = this.$refs.select_driver.selected;
      if (!this.$refs.select_driver.selected) {
        driver_ids = this.$refs.select_driver.options;
      }
      if (driver_ids.length > 0) {
        driver_ids = driver_ids.map((item) => item.id);
      }
      this.driverIDs = driver_ids.join(",");

      if (this.warehouseIDs == null) {
        this.$vs.notify({
          title: "Error",
          text: "Please select warehouse",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      // let warehouse_ids = [];
      // warehouse_ids = this.$refs.select_warehouse.selected;
      // if (warehouse_ids.length > 0) {
      //   warehouse_ids = warehouse_ids.map((item) => item.id);
      // }
      // this.warehouseIDs = warehouse_ids.join(",");

      if (this.validity.startDate == null || this.validity.endDate == null) {
        this.$vs.notify({
          title: "Error",
          text: "Please select date",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      this.$vs.loading();

      var filetitle =
        "DAILY_CLOSING_REPORT_" + moment().format("YYYYMMDDHHmmss");
      this.$http
        .get(this.baseUrl + "/export", {
          params: {
            file: file,
            title: filetitle,
            driver_ids: this.driverIDs,
            start_date: this.validity.startDate
              ? moment(this.validity.startDate).format("YYYY-MM-DD")
              : null,
            end_date: this.validity.endDate
              ? moment(this.validity.endDate).format("YYYY-MM-DD")
              : null,
            warehouse_ids: this.warehouseIDs,
            daily_closing_status: this.dailyClosingStatusIDs,
            only_exception: this.onlyException,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Processing",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        });
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleChangePage(page) {
      this.table.page = page;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    async getData() {
      let driver_ids = [];
      driver_ids = this.$refs.select_driver.selected;
      if (!this.$refs.select_driver.selected) {
        driver_ids = this.$refs.select_driver.options;
      }
      if (driver_ids.length > 0) {
        driver_ids = await driver_ids.map((item) => item.id);
      }
      this.driverIDs = driver_ids.join(",");

      console.log(this.warehouseIDs)
      if (this.warehouseIDs == null) {
        this.$vs.notify({
          title: "Error",
          text: "Please select warehouse",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      // let warehouse_ids = [];
      // warehouse_ids = this.$refs.select_warehouse.selected;
      // if (warehouse_ids.length > 0) {
      //   warehouse_ids = await warehouse_ids.map((item) => item.id);
      // }
      // this.warehouseIDs = warehouse_ids.join(",");

      if (this.validity.startDate == null || this.validity.endDate == null) {
        this.$vs.notify({
          title: "Error",
          text: "Please select date",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      this.$vs.loading();

      let params = {
        ...this.table,
        driver_ids: this.driverIDs,
        start_date: this.validity.startDate
          ? moment(this.validity.startDate).format("YYYY-MM-DD")
          : null,
        end_date: this.validity.endDate
          ? moment(this.validity.endDate).format("YYYY-MM-DD")
          : null,
        warehouse_ids: this.warehouseIDs,
        daily_closing_status: this.dailyClosingStatusIDs,
        only_exception: this.onlyException,
      };

      let results = await this.$http.get(
        this.baseUrl + "/report",
        {
          params: params,
        }
      );

      if (results.code == 200) {
        if (results.data != null) {
          this.table.data = results.data.records;
        }
        this.$vs.notify({
          title: "Success",
          text: results.message,
          color: "success",
        });
        this.$vs.loading.close();
      } else {
        this.table.data = [];
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Failed",
          text: results.message,
          color: "danger",
        });
      }

      this.table.total = results.data.total_record;
      this.table.totalPage = results.data.total_page;
      this.table.totalSearch = results.data.total_record_search;
      this.table.length = results.data.total_record_per_page;
      this.table.row_number_start = results.data.row_number_start;
      this.table.row_number_end = results.data.row_number_end;

      this.setStartEnd();

      this.$vs.loading.close();
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        is_export_excel: false,
        row_number_start: 0,
        row_number_end: 0,
      };
    },
    async handleFilter() {
      await this.getData();
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("DD MMM YYYY");
      }
      return a;
    },
    formatDateTime(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .add(-7, "h")
          .utc()
          .local()
          .format("DD-MM-YYYY HH:mm:ss");
      }
    },
    formatDate(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value).format("DD-MM-YYYY");
      }
    },
    formatNumber(value) {
      if (value == 0 || value == null) {
        return "0"
      }
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
  },
  mounted() { },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {
    warehouseIDs: function (val) {
      this.$refs.select_driver.reset();
      if (!val) {
        return;
      }
      let params = {
        warehouse_id: val,
        length: 0,
      };
      this.$refs.select_driver.getDataByTerritory(params);

    },
    validity() {
      // merge start and end date and format it to YYYY-MM-DD
      let startDate = moment(this.validity.startDate).format("YYYY-MM-DD");
      let endDate = moment(this.validity.endDate).format("YYYY-MM-DD");
      let formatDate = startDate + "," + endDate;
      this.$emit("data", formatDate);
    },
    selectedDailyClosingStatus: {
      handler(newVal, oldVal) {
        if (newVal) {
          const ALL = this.optionDailyClosingStatus.find(item => item.id === 0);

          const ids = newVal.map(item => item.id);
          this.dailyClosingStatusIDs = ids.join(',');

          if (ids[0] == 0 && ids.length > 1) {
            this.selectedDailyClosingStatus.shift()
          } else if (ids.includes(0) && ids.length > 1) {
            this.dailyClosingStatusIDs = "0"
            this.selectedDailyClosingStatus = [ALL];
          }
        }
      },
      deep: true
    },
  },
};
</script>
